"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormContext = exports.FormProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const reactiveState_1 = require("../reactiveState");
const HookFormContext = (0, react_1.createContext)({});
const FormProvider = ({ children, Field, control, state }) => {
    const data = (0, react_1.useMemo)(() => ({ Field, control, state }), [Field, control, state]);
    return (0, jsx_runtime_1.jsx)(HookFormContext.Provider, { value: data, children: children });
};
exports.FormProvider = FormProvider;
const useFormContext = () => {
    const context = (0, react_1.useContext)(HookFormContext);
    const [state] = (0, reactiveState_1.useReactiveState)(context.state);
    return { state, control: context.control, Field: context.Field };
};
exports.useFormContext = useFormContext;
//# sourceMappingURL=useFormContext.js.map